/**
 * Tools for clear.
 * @module clear
 * @license MIT
 * @copyright 2011 Jeff Schiller
 */
import { NS } from '../common/namespaces';
import SvgCanvas from './svgcanvas';

let currentCanvas_: SvgCanvas = null;

/**
* @function module:clear.init
* @param {module:clear.SvgCanvas#init} clearContext
* @returns {void}
*/
export const init = function (svgCanvas: SvgCanvas) {
    currentCanvas_ = svgCanvas;
};

/**
* This function resets the svgcontent element while keeping it in the DOM.
* @function module:svgcanvas.SvgCanvas#clearSvgContentElement
* @returns {void}
*/
export const clearSvgContentElementInit = function () {
    const curConfig = currentCanvas_.getCurrentConfig();
    const { dimensions } = curConfig;
    const el = currentCanvas_.getSVGContent();

    // empty()
    while (el.firstChild) {
        el.removeChild(el.firstChild);
    }

    // TODO: Clear out all other attributes first?
    const pel = currentCanvas_.getSVGRoot();
    el.setAttribute('id', 'svgcontent');
    el.setAttribute('width', dimensions[0]);
    el.setAttribute('height', dimensions[1]);
    el.setAttribute('x', dimensions[0]);
    el.setAttribute('y', dimensions[1]);
    el.setAttribute('overflow', curConfig.show_outside_canvas ? 'visible' : 'hidden');
    el.setAttribute('xmlns', NS.SVG);
    for (const key in NS) {
        if (key.indexOf("Alias") >= 0) {
            continue;
        }

        const xmlnsKey = key.replace(/_/g, "").toLowerCase();
        el.setAttribute(`xmlns:${xmlnsKey}`, NS[key]);
    }
    el.setAttribute("zaa:dpi", "96");
    el.setAttribute("zaa:version", "2");
    el.setAttribute("zaa:document-notes", "");
    pel.appendChild(el);
};
